/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_OverlineInputs */

const en_cp_faq_overline = /** @type {(inputs: Cp_Faq_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QUESTIONS`)
};

const id_cp_faq_overline = /** @type {(inputs: Cp_Faq_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PERTANYAAN`)
};

/**
* | output |
* | --- |
* | "QUESTIONS" |
*
* @param {Cp_Faq_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_overline = /** @type {((inputs?: Cp_Faq_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_overline(inputs)
	return en_cp_faq_overline(inputs)
});